 <head>

</head>

<body>
    <div class="intro">
        <div class="container">


            <!-- Delete Form -->
            <!-- Form -->
            <div *ngIf="show_customerDelete_form===true">
                <!-- Title -->
                <h3>
                    <br><br><br>
                    <span id="title" class="pacificofont"><b><i>Delete Customer</i></b></span>
                    <br><br><br>
                </h3>
                <!-- Title -->
                <div id="model_popup" class="fancy">
                    <p id="delete"
                        style="text-align:center;font-size:
                        22px;"><b>Are You Sure You Want to Delete
                            Customer {{
                            customerEditName }} </b></p><br><hr>
                    <button style="margin-left:100px;width:80px"
                        id="delete_button"
                        (click)="onClose()" type="button"
                        class="btn
                        btn-outline-primary">Cancel</button>
                    <button style="margin-left:150px;"
                        id="delete_button"
                        (click)="deleteCustomer()" type="button"
                        class="btn
                        btn-outline-danger">Delete</button>
                </div>
            </div>
            <!-- Delete Form -->


            <!-- Add Customer Form -->
            <div *ngIf="show_customerAdd_form === true">
                <!-- Title -->
                <h3>
                    <br><br><br>
                    <span id="title" class="pacificofont"><b><i>Add Customer</i></b></span>
                    <br><br><br>
                </h3>
                <!-- Title -->


                <!-- Form -->
                <form id=addCustomerForm #addCustomerForm="ngForm"
                    (ngSubmit)="addCustomer(addCustomerForm)">
                    <div>


                        <!-- Close Icon -->
                        <p onmouseover="" style="cursor:
                            pointer;text-align:right;font-size:40px;"><a
                                (click)="onClose()" style="color:black"
                                class="close">&times;</a></p>
                        <!-- Close Icon -->


                        <!-- Customer Name -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerName">Name</label>
                            <input #customerName="ngModel"
                                required
                                type="text" class="form-control"
                                placeholder="Enter Name"
                                id="customerName"
                                list="customerNameList"
                                aria-describedby="customerName"
                                ngModel
                                name="customerName">
                            <datalist id="customerNameList">
                                <option *ngFor="let customer of customerList">{{customer.customerName}}</option>
                            </datalist>
                        </div>
                        <!-- Customer Name -->

                        <!-- Customer Contact -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerContact">Mobile Number</label>
                            <input #customerContact="ngModel"
                                pattern=\d\d\d\d\d\d\d\d\d\d
                                type="text" class="form-control"
                                id="customerContact"
                                list="customerContactList"
                                aria-describedby="customerContact"
                                placeholder="Enter Mobile Number"
                                ngModel
                                name="customerContact">
                            <datalist id="customerContactList">
                                <option *ngFor="let customer of customerList">{{customer.customerContact}}</option>
                            </datalist>
                            <span id="input_label"
                                *ngIf="customerContact.invalid &&
                                customerContact.touched"
                                style="color:red"><b>**Mobile Number
                                    Should
                                    be
                                    10 digits</b></span>
                        </div>
                        <!-- Customer Contact -->


                        <!-- Customer Adress -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerAddress">Address</label>
                            <input #customerAddress="ngModel"
                                type="text" class="form-control"
                                placeholder="Enter Address"
                                id="customerAddress"
                                autocomplete="off"
                                aria-describedby="customerAddress"
                                ngModel
                                name="customerAddress">
                        </div>
                        <!-- Customer Adress -->


                        <!-- Customer Aadhar Number -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerAadharNumber">Aadhar
                                Card
                                Number</label>
                            <input #customerAadharNumber="ngModel"
                                pattern="\d\d\d\d\d\d\d\d\d\d\d\d"
                                type="text" class="form-control"
                                placeholder="Enter Aadhar Number"
                                id="customerAadharNumber"
                                autocomplete="off"
                                aria-describedby="customerAadharNumber"
                                ngModel
                                name="customerAadharNumber">
                            <span id="input_label"
                                *ngIf="customerAadharNumber.invalid
                                &&
                                customerAadharNumber.touched"
                                style="color:red"><b>**Aadhar card
                                    Number
                                    should
                                    be 12 digits</b></span>
                        </div>
                        <!-- Customer Aadhar Number -->


                        <!-- Customer Pan Number -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerPanNumber">Pan Card
                                Number</label>
                            <input #customerPanNumber="ngModel"
                                type="text" class="form-control"
                                placeholder="Enter Pan Number"
                                id="customerPanNumber"
                                autocomplete="off"
                                aria-describedby="customerPanNumber"
                                ngModel
                                name="customerPanNumber">
                        </div>
                        <!-- Customer Pan Number -->


                        <!-- Customer DOB -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerDOB">Date of Birth</label>
                            <input #customerDOB="ngModel"
                                type="date" class="form-control"
                                placeholder="Enter Date of Birth"
                                id="customerDOB"
                                autocomplete="off"
                                aria-describedby="customerDOB"
                                ngModel
                                name="customerDOB">
                        </div>
                        <!-- Customer DOB -->


                        <!-- Customer Debit -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerDebit">Debit Amount</label>
                            <input #customerDebit="ngModel"
                                type="text" class="form-control"
                                id="customerDebit"
                                autocomplete="off"
                                aria-describedby="customerDebit"
                                placeholder="Enter Debit Amount"
                                ngModel
                                name="customerDebit">
                        </div>
                        <!-- Customer Debit -->

                        <!-- Customer Credit -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerCredit">Credit Amount</label>
                            <input #customerCredit="ngModel"
                                type="text" class="form-control"
                                id="customerCredit"
                                autocomplete="off"
                                aria-describedby="customerCredit"
                                placeholder="Enter Credit Amount"
                                ngModel
                                name="customerCredit">
                        </div>
                        <!-- Customer Credit -->


                        <!-- Submit Button -->
                        <button id="submit_button" type="submit"
                            [disabled]="addCustomerForm.invalid"
                            class="btn
                            btn-danger">Add</button>
                        <!-- Submit Button -->



                    </div>
                </form>
                <!-- Form -->
            </div>
            <!-- Add Customer Form -->


            <!-- Transaction Form -->
            <div *ngIf="show_transaction_form === true">
                <!-- Title -->
                <h3>
                    <br><br><br>
                    <span id="title" class="pacificofont"><b><i>Add Transaction</i></b></span>
                    <br><br><br>
                </h3>
                <!-- Title -->


                <!-- Form -->
                <form id=transactionForm #transactionForm="ngForm"
                    (ngSubmit)="transaction(transactionForm)">

                    <div>

                        <!-- Close Icon -->
                        <p onmouseover="" style="cursor:
                            pointer;text-align:right;font-size:40px;"><a
                                (click)="onClose()" style="color:black"
                                class="close">&times;</a></p>
                        <!-- Close Icon -->


                        <!-- Customer Name -->
                        <div class="form-group">
                            <label id="input_label"
                                for="transactionName">Name</label>
                            <input #transactionName="ngModel"
                                disabled
                                type="text" class="form-control"
                                placeholder={{customerEditName}}
                                id="transactionName"
                                autocomplete="off"
                                aria-describedby="transactionName"
                                ngModel
                                name="transactionName">
                        </div>
                        <!-- Customer Name -->


                        <!-- Customer Debit -->
                        <div class="form-group">
                            <label id="input_label"
                                for="transactionDebit">New Debit
                                Amount</label>
                            <input #transactionDebit="ngModel"
                                type="text" class="form-control"
                                id="transactionDebit"
                                autocomplete="off"
                                aria-describedby="transactionDebit"
                                placeholder="Enter Debit Amount"
                                ngModel
                                name="transactionDebit">
                        </div>
                        <!-- Customer Debit -->

                        <!-- Customer Credit -->
                        <div class="form-group">
                            <label id="input_label"
                                for="transactionCredit">Credit
                                Amount</label>
                            <input #transactionCredit="ngModel"
                                type="text" class="form-control"
                                id="transactionCredit"
                                autocomplete="off"
                                placeholder="Enter Credit Amount"
                                aria-describedby="transactionCredit"
                                ngModel
                                name="transactionCredit">
                        </div>
                        <!-- Customer Credit -->

                        <!-- Submit Button -->
                        <button id="submit_button" type="submit"
                            [disabled]="transactionForm.invalid"
                            class="btn
                            btn-danger">Transaction</button>
                        <!-- Submit Button -->



                    </div>
                </form>
                <!-- Form -->
            </div>
            <!-- Transaction Form -->


            <!-- Edit Form -->
            <div *ngIf="show_customerEdit_form === true">
                <!-- Title -->
                <h3>
                    <br><br><br>
                    <span id="title" class="pacificofont"><b><i>Edit Customer</i></b></span>
                    <br><br><br>
                </h3>
                <!-- Title -->


                <!-- Form -->
                <form id=customerEditForm #customerEditForm="ngForm"
                    (ngSubmit)="editCustomer(customerEditForm)">
                    <div>

                        <!-- Close Icon -->
                        <p onmouseover="" style="cursor:
                            pointer;text-align:right;font-size:40px;"><a
                                (click)="onClose()" style="color:black"
                                class="close">&times;</a></p>
                        <!-- Close Icon -->


                        <!-- Customer Name -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerName">Name</label>
                            <input #customerName="ngModel"
                                type="text" class="form-control"
                                placeholder={{customerEditName}}
                                id="customerName"
                                autocomplete="off"
                                aria-describedby="customerName"
                                ngModel
                                name="customerName">
                        </div>
                        <!-- Customer Name -->


                        <!-- Customer Contact -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerContact">Mobile Number</label>
                            <input #customerContact="ngModel"
                                pattern="\d\d\d\d\d\d\d\d\d\d"
                                type="text" class="form-control"
                                id="customerContact"
                                autocomplete="off"
                                aria-describedby="customerContact"
                                placeholder={{customerEditContact}}
                                ngModel
                                name="customerContact">
                            <span id="input_label"
                                *ngIf="customerContact.invalid &&
                                customerContact.touched"
                                style="color:red"><b>**Mobile Number
                                    Should
                                    be
                                    10 digits</b></span>
                        </div>
                        <!-- Customer Contact -->


                        <!-- Customer Adress -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerAddress">Address</label>
                            <input #customerAddress="ngModel"
                                type="text" class="form-control"
                                placeholder={{customerEditAddress}}
                                id="customerAddress"
                                autocomplete="off"
                                aria-describedby="customerAddress"
                                ngModel
                                name="customerAddress">
                        </div>
                        <!-- Customer Adress -->


                        <!-- Customer Aadhar Number -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerAadharNumber">Aadhar
                                Card
                                Number</label>
                            <input #customerAadharNumber="ngModel"
                                pattern="\d\d\d\d\d\d\d\d\d\d\d\d"
                                type="text" class="form-control"
                                placeholder={{customerEditAadharNumber}}
                                id="customerAadharNumber"
                                autocomplete="off"
                                aria-describedby="customerAadharNumber"
                                ngModel
                                name="customerAadharNumber">
                            <span id="input_label"
                                *ngIf="customerAadharNumber.invalid
                                &&
                                customerAadharNumber.touched"
                                style="color:red"><b>**Aadhar card
                                    Number
                                    should
                                    be 12 digits</b></span>
                        </div>
                        <!-- Customer Aadhar Number -->


                        <!-- Customer Pan Number -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerPanNumber">Pan Card
                                Number</label>
                            <input #customerPanNumber="ngModel"
                                type="text" class="form-control"
                                placeholder={{customerEditPanNumber}}
                                id="customerPanNumber"
                                autocomplete="off"
                                aria-describedby="customerPanNumber"
                                ngModel
                                name="customerPanNumber">
                        </div>
                        <!-- Customer Pan Number -->

                        <!-- Customer DOB -->
                        <div class="form-group">
                            <label id="input_label"
                                for="customerDOB">Date of Birth</label>
                            <input #customerDOB="ngModel"
                                type="date" class="form-control"
                                placeholder={{customerEditDOB}}
                                id="customerDOB"
                                autocomplete="off"
                                aria-describedby="customerDOB"
                                ngModel
                                name="customerDOB">
                        </div>
                        <!-- Customer DOB -->

                        <!-- Submit Button -->
                        <button id="submit_button" type="submit"
                            [disabled]="customerEditForm.invalid"
                            class="btn
                            btn-danger">Edit</button>
                        <!-- Submit Button -->



                    </div>
                </form>
                <!-- Form -->
            </div>
            <!-- Edit Form -->


            <!-- Customer Table -->
            <div *ngIf="show_customerEdit_form === false &&
                show_transaction_form === false &&
                show_customerAdd_form
                ===
                false && show_customerDelete_form===false &&
                show_copyCustomer_form===false">

                <!-- Title -->
                <div style="text-align: center">
                    <h2>
                        <span
                            style="position:relative;top:20px;color:white"
                            class="pacificofont"><b><i>{{
                                    businessName|titlecase }} Customers</i></b></span>
                    </h2>
                </div>
                <!-- Title -->


                <!-- Search Bar -->
                <div class="form-group">
                    <input id="searchBar" type="text"
                        class="form-control"
                        [(ngModel)]="text"
                        name="text"
                        (ngModelChange)="Search()"
                        placeholder="Search">
                </div>
                <!-- Search Bar -->


                <!-- Create Excel Button -->
                <div *ngIf="show_createExcel === false">

                    <button
                        style="position:relative;top:14px;margin-left:970px;"
                        type="button"
                        class="btn
                        btn-success" (click)="createCustomersCSV()"><i class="fa
                            fa-file-excel-o"></i> Create Excel</button>

                </div>


                <div *ngIf="show_createExcel === true">

                    <button
                        style="position:relative;top:14px;margin-left:970px;"
                        type="button"
                        class="btn btn-success"
                        disabled>
                        <span class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                        Creating...</button>

                </div>
                <!-- Create Excel Button -->

                <!-- Create Pdf Button -->
                <div *ngIf="show_createPdf === false">

                    <button
                        style="position:relative;bottom:40px;margin-left:840px;"
                        type="button"
                        class="btn
                        btn-danger" (click)="createCustomersPdf()"><i class="fa
                            fa-file-excel-o"></i> Create Pdf</button>

                </div>


                <div *ngIf="show_createPdf === true">

                    <button
                        style="position:relative;bottom:40px;margin-left:840px;"
                        type="button"
                        class="btn btn-danger"
                        disabled>
                        <span class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                        Creating...</button>

                </div>
                <!-- Create Pdf Button -->



                <!-- Add New User Button -->
                <button
                    style="position:relative;bottom:94px;margin-left:730px;"
                    type="button" class="btn btn-info add-new"
                    (click)=addCustomerForm()><i class="fa fa-plus"></i> Add
                    New</button>
                        <div *ngIf="text === '';then content else
                            other_content"></div>
                <!-- Add New User Button -->

                <!-- Copy User Button -->
                <a href="/copy/{{businessId}}/"><button
                    style="position:absolute;top:120px;margin-left:650px;"
                    type="button" class="btn btn-warning"><i class="fa
                        fa-copy"></i>
                    More</button></a>
            <!-- Copy User Button -->

                    <!-- Customer List Pagination Table -->
                    <ng-template #content>
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th (click)="sort('customerId')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Sr</th>
                                    <th (click)="sort('customerName')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Name</th>
                                    <th
                                        (click)="sort('customerCredit')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Credit</th>
                                    <th (click)="sort('customerDebit')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Debit</th>
                                    <th (click)="sort('customerPending')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Pending</th>
                                    <th (click)="sort('customerContact')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Contact</th>
                                    <th (click)="sort('customerAddress')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Address</th>
                                    <th (click)="sort('customerAadharNumber')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Aadhar
                                        No.</th>
                                    <th (click)="sort('customerPanNumber')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Pan
                                        No.</th>
                                    <th (click)="sort('customerDOB')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;DOB</th>
                                    <th class="table-dark">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-light" *ngFor="let
                                    customer
                                    of
                                    customerList | orderBy: key :
                                    reverse |
                                    paginate : {id :
                                    'listing_pagination',
                                    itemsPerPage : 10,
                                    currentPage : page,
                                    totalItems : totalLength
                                    }; let i=index">
                                    <td>{{ (page - 1) * 10 + i +1 }}</td>
                                    <td><a
                                            href="/transaction/{{businessId}}/{{customer.customerId}}">{{customer.customerName}}</a></td>
                                    <td>{{customer.customerCredit}}</td>
                                    <td>{{customer.customerDebit}}</td>
                                    <td>{{customer.customerPending}}</td>
                                    <td>{{customer.customerContact}}</td>
                                    <td>{{customer.customerAddress}}</td>
                                    <td>{{customer.customerAadharNumber}}</td>
                                    <td>{{customer.customerPanNumber}}</td>
                                    <td>{{customer.customerDOB}}</td>
                                    <td>
                                        <a style="color: #FFC107;"
                                            class="edit"
                                            title="Edit"
                                            data-toggle="tooltip"
                                            (click)="editCustomerForm(customer)"><i
                                                class="material-icons">&#xE254;</i></a>
                                        <a style="color: #E34724;"
                                            class="delete"
                                            title="Delete"
                                            data-toggle="tooltip"
                                            (click)="deleteCustomerForm(customer)"><i
                                                class="material-icons">&#xE872;</i></a>
                                        <a style="color: green;"
                                            class="delete"
                                            title="Transaction"
                                            data-toggle="tooltip"
                                            (click)="transactionForm(customer)"><i
                                                class="material-icons">&#xe263;</i></a>
                                        <a style="color: blue;"
                                            class="delete"
                                            title="info"
                                            data-toggle="tooltip"
                                            href="/profit/{{businessId}}/{{customer.customerId}}"><i
                                                class="material-icons">&#xe88f;</i></a>
                                    </td>
                                </tr>

                            </tbody>
                            <tbody>
                                <tr class="table-info">
                                    <td></td>
                                    <td>Total </td>
                                    <td>{{totalCredit}}</td>
                                    <td>{{totalDebit}}</td>
                                    <td>{{totalPending}}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                        <div>
                            <pagination-controls style="color:white;"
                                id="listing_pagination"
                                (pageChange)="page=
                                $event"></pagination-controls>
                        </div>
                    </ng-template>
                    <!-- Customer List Pagination Table -->


                    <!-- Customer List Search Table -->
                    <ng-template #other_content>
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th (click)="sort('customerId')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Sr</th>
                                    <th (click)="sort('customerName')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Name</th>
                                    <th (click)="sort('customerCredit')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Credit</th>
                                    <th (click)="sort('customerDebit')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Debit</th>
                                    <th (click)="sort('customerPending')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Pending</th>
                                    <th (click)="sort('customerContact')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Contact</th>
                                    <th (click)="sort('customerAddress')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Address</th>
                                    <th (click)="sort('customerAadharNumber')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Aadhar
                                        No.</th>
                                    <th (click)="sort('customerPanNumber')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;Pan
                                        No.</th>
                                    <th (click)="sort('customerDOB')"
                                        class="table-dark"><i class="fa
                                            fa-sort"></i>&nbsp;DOB</th>
                                    <th class="table-dark">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-light" *ngFor="let customer of
                                    customerList | orderBy: key :
                                    reverse | filter:text; let i=index">
                                    <td>{{ (page - 1) * 10 + i +1 }}</td>
                                    <td><a
                                            href="/transaction/{{businessId}}/{{customer.customerId}}">{{customer.customerName}}</a></td>
                                    <td>{{customer.customerCredit}}</td>
                                    <td>{{customer.customerDebit}}</td>
                                    <td>{{customer.customerPending}}</td>
                                    <td>{{customer.customerContact}}</td>
                                    <td>{{customer.customerAddress}}</td>
                                    <td>{{customer.customerAadharNumber}}</td>
                                    <td>{{customer.customerPanNumber}}</td>
                                    <td>{{customer.customerDOB}}</td>
                                    <td>
                                        <a style="color: #FFC107;"
                                            class="edit"
                                            title="Edit"
                                            data-toggle="tooltip"
                                            (click)="editCustomerForm(customer)"><i
                                                class="material-icons">&#xE254;</i></a>
                                        <a style="color: #E34724;"
                                            class="delete"
                                            title="Delete"
                                            data-toggle="tooltip"
                                            (click)="deleteCustomerForm(customer)"><i
                                                class="material-icons">&#xE872;</i></a>
                                        <a style="color: green;"
                                            class="delete"
                                            title="Transaction"
                                            data-toggle="tooltip"
                                            (click)="transactionForm(customer)"><i
                                                class="material-icons">&#xe263;</i></a>
                                        <a style="color: blue;"
                                            class="delete"
                                            title="info"
                                            data-toggle="tooltip"
                                            href="/profit/{{businessId}}/{{customer.customerId}}"><i
                                                class="material-icons">&#xe88f;</i></a>
                                    </td>
                                </tr>

                            </tbody>
                            <tbody>
                                <tr class="table-info">
                                    <td></td>
                                    <td>Total </td>
                                    <td>{{totalCredit}}</td>
                                    <td>{{totalDebit}}</td>
                                    <td>{{totalPending}}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-template>
                <!-- Customer List Search Table -->

            </div>
        </div>
    </div>
</body>